
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 20h4s-.3 1-2 1-2-1-2-1zm9-5s1-12-7-12-7 12-7 12-2 2.5-2 3c0 .6.4 1 1 1h16c.6 0 1-.4 1-1 0-.5-2-3-2-3z"}})])
          )
        }
      }
    